import React from "react";
import Select, { components } from "react-select";

const MenuList = (props) => {
  const { children } = props;
  const childrenArray = React.Children.toArray(children);

  // Find the 'Add New' option index
  const addNewIndex = childrenArray.findIndex((child) =>
    child.props.data?.value?.toString().toLowerCase().includes("add-new")
  );

  if (addNewIndex === -1) {
    return <components.MenuList {...props}>{children}</components.MenuList>;
  }

  const addNewChild = childrenArray[addNewIndex];
  const otherOptions = childrenArray.filter((_, i) => i !== addNewIndex);

  return (
    <components.MenuList {...props}>
      <div className="flex flex-col relative">
        <div className="flex-1">{otherOptions}</div>
        <div className="sticky -bottom-1 bg-white border-t border-slate-100 z-10 shadow-[0_-4px_10px_-1px_rgba(0,0,0,0.05)]">
          {addNewChild}
        </div>
      </div>
    </components.MenuList>
  );
};

const CRMSelect = (props) => {
  const { styles, ...rest } = props;

  const defaultStyles = (error = false) => ({
    control: (base, state) => ({
      ...base,
      borderRadius: "0.75rem",
      padding: "2px 8px",
      border: error ? "1.5px solid #fda4af" : state.isFocused ? "1.5px solid #405189" : "1.5px solid #e2e8f0",
      backgroundColor: error ? "#fff1f2" : "white",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(64, 81, 137, 0.05)" : "none",
      transition: "all 0.2s ease",
      minHeight: "38px",
      "&:hover": { borderColor: state.isFocused ? "#405189" : "#cbd5e1" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    menu: (base) => ({
      ...base,
      borderRadius: "1rem",
      overflow: "hidden",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
      border: "1px solid #f1f5f9",
      padding: "4px",
      zIndex: 9999999,
    }),
    option: (base, state) => {
      const isAddNew = state.data?.value?.toString().toLowerCase().includes("add-new");
      return {
        ...base,
        borderRadius: "0.5rem",
        backgroundColor: state.isSelected
          ? "#405189"
          : state.isFocused
            ? isAddNew ? "#f0fdf4" : "#f8fafc"
            : isAddNew ? "#f8fafc" : "transparent",
        color: state.isSelected
          ? "white"
          : isAddNew ? "#16a34a" : "#475569",
        padding: "8px 12px",
        fontWeight: state.isSelected || isAddNew ? "700" : "500",
        fontSize: "0.75rem",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        transition: "all 0.15s ease",
        margin: isAddNew ? "2px 0 0 0" : "0",
        ...(isAddNew && {
          border: "1px dashed #bbf7d0",
          "&:hover": {
            backgroundColor: "#f0fdf4",
            borderColor: "#8716a3ff"
          }
        })
      };
    },
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      fontSize: "0.75rem",
      fontWeight: "500",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1e293b",
      fontWeight: "600",
      fontSize: "0.75rem",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#405189" : "#cbd5e1",
      padding: "2px",
    }),
  });

  return (
    <Select
      {...rest}
      components={{
        MenuList,
        ...props.components,
      }}
      styles={styles || defaultStyles(props.error)}
    />
  );
};

export default CRMSelect;
